import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "flex justify-between bg-white rounded-md shadow overflow-x-auto"
};
var _hoisted_2 = {
  "class": "flex justify-between items-center gap-4"
};
var _hoisted_3 = {
  "class": "p-2 text-sm"
};
var _hoisted_4 = {
  "class": "px-2 bg-blue-100 rounded-md font-bold"
};
var _hoisted_5 = /*#__PURE__*/_createTextVNode(" Companies");
var _hoisted_6 = {
  "class": "p-2 text-sm"
};
var _hoisted_7 = {
  "class": "px-2 bg-blue-100 rounded-md font-bold"
};
var _hoisted_8 = /*#__PURE__*/_createTextVNode(" Contacts");
var _hoisted_9 = {
  "class": "flex justify-between m-4"
};
var _hoisted_10 = /*#__PURE__*/_createTextVNode(" Download ");
var _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  "class": "pl-2"
}, [/*#__PURE__*/_createElementVNode("img", {
  "class": "w-4",
  src: "/images/microsoftexcel-icon.svg"
})], -1);
var _hoisted_12 = [_hoisted_10, _hoisted_11];
var _hoisted_13 = {
  "class": "bg-white rounded-md shadow overflow-x-auto my-6"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Company Stat"
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($props.companyData['companies']), 1), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString($props.companyData['contacts']), 1), _hoisted_8])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.downloadSheet && $options.downloadSheet.apply($options, arguments);
    }),
    "class": "btn-outline flex justify-between mr-4 mb-2"
  }, _hoisted_12), _createVNode(_component_el_select, {
    "class": "capitalize",
    modelValue: $data.parameter,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.parameter = $event;
    }),
    placeholder: "Parameter"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_option, {
        value: "industry",
        label: "Industry"
      }), _createVNode(_component_el_option, {
        value: "revenue",
        label: "Revenue"
      })];
    }),
    _: 1
  }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_table, {
    data: $props.companyData[$data.parameter],
    style: {
      "width": "100%"
    }
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        prop: "parameter",
        label: $data.parameter
      }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
        prop: "companies",
        label: "Companies",
        sortable: ""
      })];
    }),
    _: 1
  }, 8, ["data"])])]);
}